import React from 'react';
import { SpacerStoryblok } from '../../../_shared/interfaces/storyblok';

const Spacer = ({ blok }: { blok: SpacerStoryblok }) => {
    return <div style={{ height: blok.spacing }} />;
};

export default Spacer;
